export default __webpack_public_path__ + "static/media/case-retreival.3396557f.png";